import { Component } from 'react';
import { toast } from 'react-toastify';
import LayoutWrapper from '../../../LayoutWrapper';
import fileIcon from '../../../assets/fileIcon.png';
import '../module.scss';

export class zipPage extends Component {
  constructor(props) {
    super(props);
    props.initialconstruct.bind(this)('zipPage');
    this.state = {
      data: [],
      selectedFile: {},
      sessionDetails: {},
      breadcrum: '',
      current_id: '',
      htmls: [],
      isFullScreen: false,
    };
  }

  componentDidMount() {
    document.addEventListener('contextmenu', (e) => {
      e.preventDefault();
    });
    this.fetchData();
    this.getBreadCums();
    document.addEventListener('fullscreenchange', this.handleFullScreenChange);
  }

  componentWillUnmount() {
    document.removeEventListener('fullscreenchange', this.handleFullScreenChange);
  }

  handleFullScreenChange = () => {
    this.setState({
      isFullScreen: !!document.fullscreenElement,
    });
  };

  toggleFullScreen = () => {
    const element = document.getElementById('zippage-iframe-container');
    if (!element) return;

    if (!document.fullscreenElement) {
      element.requestFullscreen().catch((err) => {
        console.error(`Error attempting to enable fullscreen: ${err.message}`);
      });
    } else {
      document.exitFullscreen();
    }
  };

  async fetchData() {
    try {
      localStorage.setItem('session_id', this.props.urlparams.session_id);

      const { data } = await this.props.api.apiGetContentBySession({
        session_id: this.props.urlparams.session_id,
        content_type: 'AI',
        school_id: localStorage.getItem('school_id') || '',
        class_id: localStorage.getItem('class_id') || '',
      });
      const htmls = await Promise.all(
        data.map(async (obj) => {
          const metadataPayload = {
            attachment_id: obj.attach_file,
          };

          const res = await this.props.api.apiGetFileMetaData(metadataPayload);
          console.log('Meta data: ', res?.url);
          const url = `${this.linkGeneration(obj.attach_file)}`;
          return {
            url,
            fileName: obj?.content_title || res?.file_name || 'AI Activity',
          };
        })
      );
      console.log('All HTML: ', htmls);
      this.setState({
        data: data,
        current_id: data[0]?.attach_file || '',
        selectedFile: htmls[0] || {},
        htmls: htmls,
      });
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  }

  getSelectedFile(item) {
    this.setState({
      selectedFile: item,
    });
  }

  completed(event, box) {
    if (this.props.urlparams.session_id) {
      let payload = {
        class_id: localStorage.getItem('class_id'),
        module_id: localStorage.getItem('module_id'),
        session_id: this.props.urlparams.session_id,
        content_id: box?.content_id,
        progress: event.target.checked ? 100 : 0,
      };
      console.log('event---', payload);
      this.props.api
        .apiRecordConentProgress(
          { school_id: localStorage.getItem('school_id') },
          payload
        )
        .then(({ data, total }) => {
          this.fetchData();
          toast.success('Activity Completion Status Updated', {
            autoClose: 3000,
            closeButton: false,
            hideProgressBar: true,
          });
        });
    }
  }

  routeToSession(e) {
    e.preventDefault();
    e.stopPropagation();
    let closeLink = `/contentmanagement/sessions?grade=${
      this.props.urlparams.grade
    }&level=${this.props.urlparams.level.toUpperCase()}&type=${
      this.props.urlparams.type
    }&curriculum_id=${this.props.urlparams.curriculum_id}&class_id=${localStorage.getItem(
      'class_id'
    )}`;

    const lastIndex = closeLink.lastIndexOf('?');
    const correctedCloseLink = closeLink.slice(0, lastIndex) + closeLink.slice(lastIndex + 1);
    this.props.navigate(correctedCloseLink);
  }

  getBreadCums() {
    if (this.props.urlparams.session_id) {
      let payload = {
        session_id: this.props.urlparams.session_id,
      };
      this.props.api
        .apiGetContentSessionById({
          session_id: this.props.urlparams.session_id,
        })
        .then(({ data }) => {
          // console.log("session data: ", data);
          this.setState({
            sessionDetails: data,
          });
          let breadcrum = `${
            localStorage.getItem('currentAdminRole') != 'SUPER_ADMIN'
              ? 'Content Delivery'
              : 'Content Management'
          }/${this.props.urlparams.grade} Grade/
        ${this.props.urlparams?.type}/${data.session_name} : AI`;

          this.setState({
            breadcrum: breadcrum,
          });
        });
    } else {
      return 'ZIP';
    }
  }

  getBackLink() {
    if (this.props.urlparams.course_id) {
      let backLink = `/lms/courses`;
      return backLink;
    } else {
      return '/contentmanagement';
    }
  }

  getTitle() {
    if (this.props.urlparams.grade) {
      let title = `${this.props.urlparams.grade} Grade`;
      return title;
    } else {
      return 'Session';
    }
  }

  linkGeneration(attach_file) {
    let authToken = window.store.getState().root.auth;
    return (
      app.api.request(app.apis().fileDownloader).urltransform({ attachmentId: attach_file }).url +
      '?auth=' +
      authToken
    );
  }

  render() {
    let {
      data = [],
      selectedFile,
      sessionDetails,
      breadcrum,
      htmls,
    } = this.state;
    return (
      <LayoutWrapper title={this.getTitle()} back={breadcrum} backlink={this.getBackLink()}>
        <div className="card bg-white media_box">
          <div className="card-header">
            <h3 className="title">{sessionDetails.session_name || 'AI Activity'}</h3>
          </div>
          <div className="card-body px-0">
            <div className="row g-4 mx-auto px-0">
              {selectedFile && selectedFile.url && (
                <div className="col-md-7">
                  <div id="zippage-iframe-container" className="iframe_container" style={{ minHeight: '600px', position: 'relative' }}>
                    <iframe
                      src={selectedFile.url}
                      frameBorder="0"
                      allow="autoplay; fullscreen; picture-in-picture"
                      style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        border: 'none',
                        borderRadius: '8px',
                      }}
                      title={selectedFile.fileName || sessionDetails.session_name || 'AI Activity'}
                    />
                    <button
                      onClick={this.toggleFullScreen}
                      className={`btn btn-sm position-absolute ${this.state.isFullScreen ? 'btn-danger' : 'btn-primary'}`}
                      style={{
                        top: '12px',
                        right: '12px',
                        zIndex: 1000,
                        borderRadius: '4px',
                        boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                        ...(this.state.isFullScreen ? {} : {
                          backgroundColor: '#fba106',
                          borderColor: '#fba106',
                          color: '#fff',
                        }),
                      }}
                    >
                      {this.state.isFullScreen ? (
                        <>
                          <i className="fa fa-compress" style={{ marginRight: '6px' }} />
                        </>
                      ) : (
                        <>
                          <i className="fa fa-expand" style={{ marginRight: '6px' }} />
                        </>
                      )}
                    </button>
                  </div>
                </div>
              )}
              <div className="col-12 col-md-5">
                <p className="content_description">
                  {sessionDetails.session_description}
                </p>
                <div className="mini_box_container">
                  {htmls?.length ? (
                    htmls?.map((box, j) => {
                      const isSelected =
                        selectedFile &&
                        (selectedFile === box ||
                          (selectedFile.url && selectedFile.url === box.url));

                      return (
                        <div
                          className={`mini_box ${isSelected ? 'active' : ''}`}
                          key={j}
                          onClick={() => this.getSelectedFile(box)}
                          onKeyDown={(e) => {
                            if (e.key === 'Enter' || e.key === ' ') {
                              e.preventDefault();
                              this.getSelectedFile(box);
                            }
                          }}
                          tabIndex={0}
                          role="button"
                          aria-selected={isSelected}
                        >
                          <div className="d-flex align-items-center justify-content-between w-100 gap-3">
                            <div className="d-flex align-items-center gap-3 w-100">
                              <div className="thumbnail_box">
                                <img
                                  src={fileIcon}
                                  alt="Activity Icon"
                                />
                              </div>
                              <div>
                                <p className="title mb-0">{box.fileName || box.content_title}</p>
                              </div>
                            </div>
                            <div className="flex-shrink-0 ms-2">
                              {isSelected && <i className="fa fa-check-circle text-warning fs-5" title="Selected" />}
                            </div>
                          </div>
                        </div>
                      );
                    })
                  ) : (
                    <p>Not found</p>
                  )}
                </div>
              </div>
            </div>
          </div>
          <hr />
          <div
            className="card-footer social_box"
            style={{
              position: 'static',
            }}
          >
            <button
              type="button"
              onClick={(...args) => this.routeToSession(...args)}
              className="btn add-btn min-wd-100 mr-2"
            >
              Back To Sessions
            </button>
          </div>
        </div>
      </LayoutWrapper>
    );
  }
}

export default connect(zipPage);
